export default "__VITE_ASSET__D6x8spgm__"